import type { ImpactCenterXrayAdoptionResponse } from "@shared/services/impact-center/getImpactCenterXrayAdoption.ts";

const TOUR_SERVER_NAME = "demo";

export default async (): Promise<ImpactCenterXrayAdoptionResponse> => ({
  results: [
    {
      technicalServerName: TOUR_SERVER_NAME,
      adoption: {
        totalManagedRepos: 10,
        totalWithSca: 8,
        totalWithContextualAnalysis: 5,
        totalWithSecretsDetection: 4,
        totalScaCaEligible: 6,
        totalSecretsEligible: 7,
        totalCaEligibleWithCa: 5,
        totalSecretsEligibleWithSecrets: 4,
      },
    },
  ],
});
